module.exports = __webpack_public_path__ + "assets/media/evening.d6244044.mp3";